module.exports = __webpack_public_path__ + "static/img/banner0.1b545ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner0.jpg
// module id = vYfW
// module chunks = 1